import { render, staticRenderFns } from "./InputsShadowTypeMask.vue?vue&type=template&id=53bd8873"
import script from "./InputsShadowTypeMask.vue?vue&type=script&lang=js"
export * from "./InputsShadowTypeMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports